jQuery(function(){


    jQuery('body').on('click', '#twocolumn-quote-cta', function(e){
        e.preventDefault();
        var offset = jQuery('.twocolumn-quotes__container').length;

        var request = {
            offset: offset
        };

        jQuery.get('/api/get_stories', request, function(response) {
            jQuery('.twocolumn-quotes__row').append(response);

            if(jQuery('.twocoolumn-quotes__end-results ').length > 0) {
                jQuery('#twocolumn-quote-cta').hide();
            }
        });

        return false;
    });


});